<!-- paginate -->
<ng-container *ngIf="navigationType === 'paginate'">
  <button
    data-automation-id="nav-previous-paginate-button"
    id="previous-button"
    mhe-button
    [purpose]="ButtonPurpose.Icon"
    class="page-nav previous menuBtn paginate"
    placement="bottom"
    panelClass="navigation-button-tooltip"
    [attr.aria-label]="'navigation.previous' | translate"
    [disabled]="disabled"
    [mheTooltip]="'navigation.previous' | translate"
    (click)="internalReverse()"
  >
    <i class="dpg-icon dpg-icon-system-left-arrow"></i>
  </button>
</ng-container>

<!-- presentation mode (not k5) -->
<ng-container *ngIf="navigationType === 'presentation'">
  <button
    data-automation-id="nav-previous-presentation-button"
    id="previous-button"
    mhe-button
    [purpose]="ButtonPurpose.Icon"
    class="page-nav previous menuBtn presentation"
    [attr.aria-label]="'navigation.previous' | translate"
    [disabled]="disabled"
    (click)="internalReverse()"
  >
    <i class="dpg-icon dpg-icon-system-left-arrow-white"></i>
  </button>

  <div *ngIf="chapterLabel" class="show-chapter previous fade">{{ chapterLabel }}</div>
</ng-container>
